import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getAllDestinations } from "../../api/Destination";
import Swal from "sweetalert2";
import { createHotels } from "../../api/Hotels";

const CreateHotel = ({ onSuccess }) => {
  // get all destinations
  const [destinationList, setDestinationList] = useState([]);
  useEffect(() => {
    const getDestinationList = async () => {
      const response = await getAllDestinations();
      setDestinationList(response.destinations);
    };
    getDestinationList();
  }, []);

  // react select filter function state
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);

  // state for image upload
  const [file, setFile] = useState(null);
  const [hotel, setHotel] = useState({
    hotel_name: "",
    email: "",
    phone_no: "",
    introduction: "",
    destination_id: "",
    address: "",
  });

  const handleChange = (e) => {
    setHotel({
      ...hotel,
      [e.target.name]: e.target.value,
    });
  };
  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", file);
    Object.entries(hotel).forEach(([key, value]) =>
      formData.append(key, value)
    );
    const response = createHotels(formData);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Hotel Created!",
            text: "You have successfully created a hotel!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputDestination">Destination</label>
          <Select
            className="basic-single"
            classNamePrefix="select Destination"
            // isClearable={isClearable}
            isSearchable={isSearchable}
            options={destinationList.map((destination) => ({
              value: destination._id,
              label: destination.destination_name,
            }))}
            name="destination_id"
            onChange={(e) =>
              setHotel({
                ...hotel,
                destination_id: e.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputName">Name</label>
          <input
            type="text"
            className="form-control"
            name="hotel_name"
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputEmail1">Email</label>
          <input
            type="email"
            className="form-control"
            name="email"
            onChange={handleChange}
          />
          <small id="emailHelp" className="form-text text-muted">
            We'll never share your email with anyone else.
          </small>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPhone">Phone</label>
          <input
            type="phone"
            className="form-control"
            name="phone_no"
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputHotelImage">Hotel Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            onChange={handleFileChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleFormControlAddress">Introduction</label>
          <textarea
            className="form-control"
            id="exampleFormControlAddress"
            rows="3"
            name="introduction"
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="exampleFormControlAddress">Address</label>
          <textarea
            className="form-control"
            id="exampleFormControlAddress"
            rows="3"
            name="address"
            onChange={handleChange}
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default CreateHotel;
